<template>
<div>
<div class="home-panel-wrapper">
  <div class="PrivatePlotComponrnrtList-head">
    <!--              头部页面-->
    <div class="container-head">
      <div class="container-head-title" style="text-align: left">
        <i class="icon-icon_yanjing2_yanjing2 iconfont"></i>
        <span>成果</span>
        <common-button style="float: right" size="default" type="cancel" image @click="back()">返回</common-button>
      </div>
    </div>

    <div class="PasswordBoxList-list-body-main-fastener">
      <button type="button" style="float: left;background-color: rgb(13 144 246);font-size: 15px;" class=" PasswordBoxList-list-body-main-button icon-icon_wenjianjia iconfont " @click="openFile">&nbsp;&nbsp;新建文件夹</button>
      <button type="button" style="float:left;margin-left: 10px;background-color: rgb(214 216 220);font-size: 15px;" class=" PasswordBoxList-list-body-main-button-down icon-daochu iconfont " @click="importFile">导入</button>
      <button type="button" style="float:left;margin-left: 10px;background-color: rgb(214 216 220);font-size: 15px;" class=" PasswordBoxList-list-body-main-button-down icon-xiazai iconfont " @click="download">下载</button>
      <div class="pending-items-search" style="text-align: left;">
        <input class="input-catch" placeholder="搜索"></input>
        <i class="iconfont icon-sousuo" @click="catchFilw" type="button"></i>
      </div>
    </div>

  </div>
  <div class="PrivatePlotComponrnrtList-body">
    <div class="container-private-body-list">
      <div class="private-plot-panel-list">
        <el-row style="margin-top: 20px">
          <el-col :span="6">
                <span
                  id="achievement"
                  @click="showAchievementInfo('achievement')" class="style_prevu_stop">
                  <div class="private-item-more el-icon-more">
                    <i class="private-item-right el-icon-arrow-right"></i>
                  </div>
                  <div class="private-item-in-up  iconfont" :class="from0.icon0"></div>
                  <div class="private-item-in-down">
                  <b> {{ from0.name0 }} </b>
                  </div>

                </span>

          </el-col>
          <el-col :span="6" >
                <span id="library" @click="showLibrary('library')" class="style_prevu_stop">
                  <div class="private-item-more el-icon-more">
                    <i class="private-item-right el-icon-arrow-right"></i>
                  </div>
                  <div class="private-item-in-up iconfont" :class="from1.icon1"></div>
                  <div class="private-item-in-down">
                   <b> {{ from1.name1 }} </b>
                  </div>
                </span>

          </el-col>
          <el-col :span="6">
                <span id="activity" @click="showActivity('activity')" class="style_prevu_stop">
                 <div class="private-item-more el-icon-more">
                    <i class="private-item-right el-icon-arrow-right"></i>
                  </div>
                  <div class="private-item-in-up  iconfont" :class="from2.icon2"></div>
                  <div class="private-item-in-down">
                    <b>{{ from2.name2 }}</b>
                  </div>
                </span>
          </el-col>
          <el-col :span="6" style="margin-right: 20px">
                <span id="work" @click="showWork('work')" class="style_prevu_stop">
                  <div class="private-item-more el-icon-more">
                    <i class="private-item-right el-icon-arrow-right"></i>
                  </div>
                  <div class="private-item-in-up iconfont" :class="from3.icon3"></div>
                  <div class="private-item-in-down">
                    <b>{{ from3.name3 }}</b>
                  </div>
                </span>
          </el-col>

        </el-row>
        <el-row >
          <el-col :span="6" style="margin-bottom: 40px">
                <span id="photos" @click="showPhotos('photos')" class="style_prevu_stop">
                 <div class="private-item-more el-icon-more">
                    <i class="private-item-right el-icon-arrow-right"></i>
                  </div>
                  <div class="private-item-in-up iconfont" :class="from4.icon4"></div>
                  <div class="private-item-in-down">
                    <b>{{ from4.name4 }}</b>
                  </div>
                </span>

          </el-col>
          <el-col :span="6">
                <span id="certificate" @click="showCertificate('certificate')" class="style_prevu_stop">
                 <div class="private-item-more el-icon-more">
                    <i class="private-item-right el-icon-arrow-right"></i>
                  </div>
                  <div class="private-item-in-up iconfont" :class="from5.icon5"></div>
                  <div class="private-item-in-down">
                    <b>{{ from5.name5 }}</b>
                  </div>
                </span>
          </el-col>
          <el-col :span="6">
                <span id="password-safe-box" @click="showPwdBox('password-safe-box')" class="style_prevu_stop">
                 <div class="private-item-more el-icon-more">
                    <i class="private-item-right el-icon-arrow-right"></i>
                  </div>
                  <div class="private-item-in-up iconfont" :class="from6.icon6"></div>
                  <div class="private-item-in-down" style="margin-top: -45px;line-height: 1;">
                    <b>{{ from6.name6 }}</b>
                  </div>
                </span>

          </el-col>
<!--          <el-col :span="6">-->
<!--                <span id="more" @click="showMore('more')" class="style_prevu_stop">-->
<!--                 <div class="private-item-more el-icon-more">-->
<!--                    <i class="private-item-right el-icon-arrow-right"></i>-->
<!--                  </div>-->
<!--                  <div class="private-item-in-up  icon-qita iconfont"></div>-->
<!--                  <div class="private-item-in-down">-->
<!--                    <b>更多</b>-->
<!--                  </div>-->
<!--                </span>-->

<!--          </el-col>-->

        </el-row>

      </div>
      <div class="private-item-down">
      </div>
    </div>
  </div>
  <!--  </div>-->

</div>
</div>
</template>
<script>
import http from "@/utils/axios";
import cookie from "@/utils/cookie";
import {Message} from "element-ui";
export default {
  name: "AchievementList",
  data(){
    return{
      data: [],
      from0:{
        name0:'',
        icon0: '',
      },
      from1:{
        name1:'',
        icon1: '',
      },
      from2:{
        name2:'',
        icon2: '',
      },
      from3:{
        name3:'',
        icon3: '',
      },
      from4:{
        name4:'',
        icon4: '',
      },
      from5:{
        name5:'',
        icon5: '',
      },
      from6:{
        name6:'',
        icon6:'',
      },
      parentId : '1',
    }
  },
  mounted() {
    this.getLabel();
  },
  methods:{
    back(){
      this.$router.push({path: '/privateplot/PrivatePlotList'})
    },
    openFile(){

    },
    importFile(){

    },
    download(){

    },
    //查询
    catchFilw(){

    },

    //显示标签
    getLabel(){
      let token = cookie.getCookie("token");
      http.post(window.config.api.baseUrl + '/eims-api/zld/Menu/main', {
        token: token,
        data:{
        parentId : this.parentId,
        }
      }).then(response => {
        let responseDate =  response.data;
        if (responseDate.code == '00000') {
          if (responseDate.data) {
            this.from0.name0 = responseDate.data.eimsZldMenuList[0].name;
            this.from0.icon0 = responseDate.data.eimsZldMenuList[0].icon;
            this.from1.name1 = responseDate.data.eimsZldMenuList[1].name;
            this.from1.icon1 = responseDate.data.eimsZldMenuList[1].icon;
            this.from2.name2 = responseDate.data.eimsZldMenuList[2].name;
            this.from2.icon2 = responseDate.data.eimsZldMenuList[2].icon;
            this.from3.name3 = responseDate.data.eimsZldMenuList[3].name;
            this.from3.icon3 = responseDate.data.eimsZldMenuList[3].icon;
            this.from4.name4 = responseDate.data.eimsZldMenuList[4].name;
            this.from4.icon4 = responseDate.data.eimsZldMenuList[4].icon;
            this.from5.name5 = responseDate.data.eimsZldMenuList[5].name;
            this.from5.icon5 = responseDate.data.eimsZldMenuList[5].icon;
            this.from6.name6 = responseDate.data.eimsZldMenuList[6].name;
            this.from6.icon6 = responseDate.data.eimsZldMenuList[6].icon;
          }
        }
      })
    },

    //点击展开页面
    showAchievementInfo(id) {
      this.showScalingAnimation(id,{
        path: "/privateplot/PaperList",
      })
    },

    showPwdBox(id) {
      this.showScalingAnimation(id)
    },

    showCertificate(id) {
      this.showScalingAnimation(id)
    },

    showMore(id) {
      this.showScalingAnimation(id)
    },

    showPhotos(id) {
      this.showScalingAnimation(id)
    },

    showActivity(id) {
      this.showScalingAnimation(id)
    },

    showWork(id) {
      this.showScalingAnimation(id)
    },

    showLibrary(id) {
      this.showScalingAnimation(id)
    },


    showScalingAnimation(id, obj) {
      let dom = document.getElementById(id)
      dom.setAttribute("class", "style_prevu_play")
      setTimeout(() => {
        dom.setAttribute("class", "style_prevu_stop")
        if (obj) {
          this.$router.push(obj)
        }
      }, 200)
    }
  }

}

</script>

<style scoped>
.home-panel-wrapper{
  margin: 20px;
}
.PrivatePlotComponrnrtList-head{
  width: 100%;
  height: 100%;
  border-color: rgb(187, 187, 187);
  border-width: 0px;
  border-style: solid;
  border-radius: 10px;
  font-size: 14px;
  padding: 0px;
  text-align: center;
  line-height: 20px;
  font-weight: normal;
  font-style: normal;
  background: rgb(255, 255, 255);
}
.PrivatePlotComponrnrtList-body{
  width: 100%;
  height: 100%;
  /*margin: 10px;*/
  border-color: rgb(187, 187, 187);
  border-width: 0px;
  border-style: solid;
  border-radius: 10px;
  font-size: 14px;
  padding: 0px;
  text-align: center;
  line-height: 20px;
  font-weight: normal;
  font-style: normal;
  background: rgb(255, 255, 255);
}
.container-private-body-list .private-plot-panel-list {
  text-align: center;
  background: transparent;
}


.container-private-body-list .private-plot-panel-list span {
  background-image: url('/static/images/private-item.png');
  padding: 20px;
  text-align: left;
  margin: 10px 10px;
  display: inline-block;
  /*position: inherit;*/
  width: 290px;
  height: 147px;
  border-radius: 10px;
  font-size: 40px;
}

.private-plot-panel-list > span {
  cursor: pointer;
}
.PasswordBoxList-list-body-main-fastener{
  padding: 10px;
}
.PasswordBoxList-list-body-main-button {
  border:  none;
  color: rgb(241 247 255);
  outline: none;
  border-radius: 3px;
  width: 120px;
  height: 35px;
  text-align: center;
  background-image: url('/static/images/fourbackground.png');
}
.PasswordBoxList-list-body-main-button:hover{
  background-color: #3a8ee6;
  color: white;
}
.PasswordBoxList-list-body-main-button-down{
  border: none;
  color: rgb(241 247 255);
  outline: none;
  border-radius: 3px;
  width: 85px;
  height: 35px;
  text-align: center;
  background-image: url(/static/images/fourbackground.png);
}
PasswordBoxList-list-body-main-button:hover{
  background-color: rgb(214 216 220);
  color: rgb(241 247 255);
}
.pending-items-search input{
  width: 330px;
  margin-left: 10px;
  height: 35px;
}
.private-item-in-up {
  /* margin: 15px; */
  /* margin-left: -90px; */
  left: 30px;
  line-height: 7;
  /* height: 40px; */
  position: absolute;
  bottom: 34px;
  margin-right: 10px;
  width: 80px;
  background-position: right bottom;
  height: 80px;
  position: absolute;
  background-position: right;
  background-color: white;
  border-radius: 100px;
}

.private-item-in-up:before {
  line-height: 1px;
  font-size: 60px;
  margin: 10px;
}
.private-item-in-down {
  width: 140px;
  color: white;
  /* font-weight: bold; */
  margin-top: -40px;
  /* font-size: 32px; */
  margin-left: 100px;
  /* line-height: 0px; */
  font-family: SourceHanSansSC;
  font-weight: 500;
  font-size: 32px;
  color: rgb(255, 255, 255);
  font-style: normal;
  letter-spacing: 0px;
  line-height: 48px;
  text-decoration: none;
}


.style_prevu_stop {
  display: inline-block;
  text-align: left;
  border: 0;
  width: 290px;
  height: 147px;
  position: relative;
  -webkit-transition: all 200ms ease-in;
  -webkit-transform: scale(1);
  -ms-transition: all 200ms ease-in;
  -ms-transform: scale(1);
  -moz-transition: all 200ms ease-in;
  -moz-transform: scale(1);
  transition: all 200ms ease-in;
  transform: scale(1);
}

.style_prevu_play {
  animation-duration: 200ms;
  animation-name: transformBig;
  animation-fill-mode: forwards;
  top: calc(50vh - 73px);
  left:calc(50vw - 180px);
  position: fixed;
  box-shadow: 0px 0px 150px #000000;
  -webkit-transition: all 200ms ease-in;
  -webkit-transform: scale(5);
  -ms-transition: all 200ms ease-in;
  -ms-transform: scale(5);
  -moz-transition: all 200ms ease-in;
  -moz-transform: scale(5);
  transition: all 200ms ease-in;
  transform: scale(5);
}

@keyframes transformBig {
  50%{
    opacity: 1;
  }
  to{
    opacity: .5;
  }
}


#password-safe-box {
  box-shadow: rgb(189 101 198) 0 1px 10px;
  background-color: rgb(189 101 198)
}

#certificate {
  box-shadow: rgb(83 153 243) 0 1px 10px;
  background-color: rgb(83 153 243)
}

#more {
  box-shadow: rgb(247 213 164) 0 1px 10px;
  background-color: rgb(247 213 164)
}

#photos {
  box-shadow: rgb(255 101 122) 0 1px 10px;
  background-color: rgb(255 101 122)
}

#activity {
  box-shadow: rgb(29, 221, 161) 0 1px 10px;
  background-color: rgb(29, 221, 161)
}

#work {
  box-shadow: rgb(123 114 224) 0 1px 10px;
  background-color: rgb(123 114 224)
}

#library {
  box-shadow: rgb(118, 211, 241) 0 1px 10px;
  background-color: rgb(118, 211, 241)
}

#achievement {
  box-shadow: rgb(250, 178, 85) 0 1px 10px;
  background-color: rgb(250, 178, 85)
}
.el-col-6{
  margin-top: 40px;
  /*margin-right: 20px;*/
  margin-left: 20px;
  width: 23%;
  position: relative;
}
.cIcon {
  width: 48px;
  height: 48px;
}

#idCrown path {
  fill: url(#gradientCrown);
}
.container-head{
  border-bottom: 1px solid #F5F5F5;
  padding:  20px;
  line-height: 20px;
}


.pending-items-search input{
  /*padding-left: 10px;*/
  width: 330px;
  margin-left: 10px;
  height: 35px;
  /* border-style: none; */
  /* align-items: inherit; */
  /* border-color: unset; */
  /* border-radius: 15px; */
  /* font-size: 14px; */
  /* font-weight: normal; */
  /* font-style: normal; */
  /*background: rgb(238, 244, 251);*/
  /*!* outline-color: #caecf5;*/

}
i.icon-sousuo{
  margin-left: -35px;
  color:#d3d4d5;
}
.el-icon-arrow-right:before {
  content: "\e6e0";
  color: white;
  font-size: 25px;

}
.input-catch{
  -webkit-appearance: none;
  background-color: #FFF;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  /* height: 40px; */
  line-height: 40px;
  outline: 0;
  padding: 0 15px;
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);

}
.el-icon-more:before {
  content: "\e794";
  color: white;
  font-size: 25px;
}
.private-item-more {
  font-weight: bold;
  margin-left: 230px;
  margin-top: -10px;
}
.private-item-right {

  font-weight: bold;

}
.back-paper-button{
  color: rgb(140 147 250);
  font-weight: bold;
  float: right;
  outline: none;
}
i.icon-icon_yanjing2_yanjing2{
  color: rgb(239 178 84);
  font-size: 22px;
}
.icon--yiliao-yaopin:before {
  color: rgb(244 175 83);;
}


.icon-jianqie:before {
  color: rgb(119 197 239);
  /*font-size: 140px;*/
}
.icon-Heartpulse:before{
  color: rgb(49 218 164);
}


.icon-yiliao:before {
  /*font-size: 140px;*/
  color: rgb(123 114 224);
}

.icon-mianxingyiliaotubiao:before {
  color: rgb(255 101 122);
  /*font-size: 140px;*/
}

.icon-diagnosis:before {
  color: rgb(83 153 243);;
  /*font-size: 140px;*/
}

.icon-hezuo1:before {
  color: rgb(189 101 198);
  /*font-size: 140px;*/
}

.icon-qita:before {
  color: rgb(247 213 164);
}

</style>



// WEBPACK FOOTER //
// src/pages/privateplot/AchievementList.vue